import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

// login
import login from '@/pages/login'

// index
import index from '@/pages/index'

// home
import home from '@/pages/home'

// product
import product from '@/pages/product'
import productSummary from '@/pages/product/summary'

// solution
import solution from '@/pages/solution'

// support
import support from '@/pages/support'

// story
import story from '@/pages/story'

// about
import about from '@/pages/about'

// article
import article from '@/pages/article'

let language = localStorage.getItem('lang');

export default new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                title: '登陆',
            }
        },
        {
            path: '/',
            redirect: {name: 'home'},
            component: index,
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: home,
                    meta: {
                        title: '首页',
                        isHeader: true,
                        isFooter: true,
                        isSearch: true,
                        isMessage: true,
                    }
                },
                // product
                {
                    path: '/product',
                    name: 'product',
                    component: product,
                    meta: {
                        title: language === 'cn' ? '产品' : 'Product',
                    }
                },
                {
                    path: '/product/summary',
                    name: 'productSummary',
                    component: productSummary,
                    meta: {
                        title: '产品特性',
                    }
                },
                // solution
                {
                    path: '/solution',
                    name: 'solution',
                    component: solution,
                    meta: {
                        title: '解决方案',
                    }
                },
                // support
                {
                    path: '/support',
                    name: 'support',
                    component: support,
                    meta: {
                        title: '技术文档',
                    }
                },
                // story
                {
                    path: '/story',
                    name: 'story',
                    component: story,
                    meta: {
                        title: '客户故事',
                    }
                },
                {
                    path: '/about',
                    name: 'about',
                    component: about,
                    meta: {
                        title: '关于我们',
                    }
                },
                // article
                {
                    path: '/article',
                    name: 'article',
                    component: article,
                    meta: {
                        title: '文章详情',
                    }
                },
            ],
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js